module.exports = __webpack_public_path__ + "static/media/DSCF5789.1817748d.jpg";